import { CanvasContext } from '@cog/ecs-canvas-2d-plugin'

export const clearScreen = (ctx: CanvasContext) => {
  ctx.graphics.gfx.clearRect(0, 0, ctx.width, ctx.height)
}
